import { Component, OnInit, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from './services/user-service/user.service';
import { ChatBroadcaster } from './services/chat-broadcaster/chat-broadcaster';
import { BroadcasterEvent } from './models/broadcaster-events.enum';
import { ChatService } from './services/chat-service/chat.service';
import { LocalStorageItem } from './models/localstorage-item.enum';
import { combineLatest } from 'rxjs';

enum PageState {
  LOADING,
  SUCCESS,
  ERROR
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'DarwinChat';
  operatorName = '';

  public pageState = PageState.LOADING;
  public PageStateEnum = PageState;

  constructor(private router: Router,
              private userService: UserService,
              private broadcaster: ChatBroadcaster,
              private chatService: ChatService,
              private ngZone: NgZone) {}

  ngOnInit()
  {
    this.broadcaster.on(BroadcasterEvent.EVENT_DEF_MSG)
    .subscribe((messages: string) =>
    {
      // Convert messages to a JSON object
      let predefinedMessages = JSON.parse(messages);
      this.chatService.predefinedMessages.setMessages(predefinedMessages.messages);
    });

    combineLatest([this.broadcaster.on(BroadcasterEvent.EVENT_JWT), this.broadcaster.on(BroadcasterEvent.EVENT_DESPATCH_GROUP)])
    .subscribe(([jwt, despatchGroups]: [string, string]) => {
      this.ngZone.run(() =>
      {
        // Run inside the ngZone to trigger change detection.
        this.pageState = PageState.LOADING;

        if (this.userService.isJWTValid(jwt))
        {
          this.operatorName = this.userService.getOperatorName();

          this.router.navigateByUrl('/chat');

          this.chatService.setDespatchGroups(JSON.parse(despatchGroups).despatchGroups);

          this.handleOldRecentChats();

          this.pageState = PageState.SUCCESS;

        }
        else
        {
          this.pageState = PageState.ERROR;
        }
      });
    })
  }

  private handleOldRecentChats()
  {
    let oldRecentChats = this.chatService.getOldRecentChats();

    if ((oldRecentChats) &&
        (oldRecentChats.length))
    {
      this.chatService.setRecentChats(oldRecentChats);
    }

    this.chatService.setFilteredChatsByDespGroup();

    localStorage.removeItem(LocalStorageItem.RECENT_CHATS);
  }
}
